export class HexUtils {
  static toHex(val: number, padding = 2): string {
    return val.toString(16).toUpperCase().padStart(padding, '0');
  }

  static toAscii(val: number): string {
    return val >= 32 && val <= 126 ? String.fromCharCode(val) : '.';
  }

  /**
   * Replaces occurrences of a byte with another byte within a specific range.
   * Returns a new buffer with changes, or null if no changes were made.
   */
  static replaceRange(
    buffer: Uint8Array,
    start: number,
    end: number,
    findVal: number,
    replaceVal: number
  ): Uint8Array | null {
    if (start < 0 || end > buffer.length || start >= end) {
      return null;
    }

    let count = 0;
    // dry run first to avoiding copying if not needed?
    // Or just copy and verify. Copy is expensive for large images.
    // Let's iterate first.
    let found = false;
    for (let i = start; i < end; i++) {
      if (buffer[i] === findVal) {
        found = true;
        break;
      }
    }

    if (!found) return null;

    const newBuffer = new Uint8Array(buffer);
    for (let i = start; i < end; i++) {
      if (newBuffer[i] === findVal) {
        newBuffer[i] = replaceVal;
        count++;
      }
    }

    return newBuffer;
  }
}
